import { render, staticRenderFns } from "./imgG.vue?vue&type=template&id=369bfa8e"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('369bfa8e')) {
      api.createRecord('369bfa8e', component.options)
    } else {
      api.reload('369bfa8e', component.options)
    }
    module.hot.accept("./imgG.vue?vue&type=template&id=369bfa8e", function () {
      api.rerender('369bfa8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgG.vue"
export default component.exports